import { render, staticRenderFns } from "./ProfileReviews.vue?vue&type=template&id=5e4e5dc9&scoped=true&"
import script from "./ProfileReviews.vue?vue&type=script&lang=js&"
export * from "./ProfileReviews.vue?vue&type=script&lang=js&"
import style0 from "./ProfileReviews.vue?vue&type=style&index=0&id=5e4e5dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e5dc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
